import React from 'react';
import { Link } from 'react-router-dom';
import { FiTrash2, FiEdit } from 'react-icons/fi';

const sellerItem = (props) => {
    console.log(props);

    return (
        <tr>
            <td>
                {props.name}
            </td>
            <td>
                {props.phone}
            </td>
            <td>
                {props.translation[props.type]}
            </td>
            <td>
                {props.email}
            </td>
            <td>
                {props.password}
            </td>
            <td>
                <Link to={`/sellers/${props.id}/edit`} className="btn btn-sm btn-outline-success mr-2"><FiEdit /> </Link>
                <button
                    onClick={() => props.delete(props.id)}
                    className="btn btn-sm btn-outline-danger"
                ><FiTrash2 /></button>
            </td>
        </tr>

    )
}

export default sellerItem;